import React, { useEffect, useState, useRef } from 'react';
import TextfieldInput from '../../Shared/TextField';
import DateSelectionFuture from "../../Shared/DateSelection/DateSelectionFuture";
import TableDragResources from '../../Shared/Tables/TableDragResources';
import DescriptionItem from '../../Shared/DescriptionItem';
import DropdownCompanyAdd from './Components/DropdownCopmanyAdd';
import DropdownResources from '../../Shared/Dropdowns/DropdownResources';
import ButtonNormalText from '../../Shared/Buttons/ButtonNormalText';
import BoolToggle from '../../Shared/Buttons/BoolToggle';
import { dataService } from '../../../Services/data/data.service';
import { Grid2, Divider, DialogTitle, DialogContentText, DialogContent, DialogActions, Dialog, Box, Typography, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Save, CircleHelp } from 'lucide-react';
import { makeStyles } from "@material-ui/core/styles";
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { Spin } from "react-cssfx-loading";
import HeaderBar from '../../Shared/Header/HeaderBar';
import HeaderTitle from '../../Shared/Header/HeaderTitle';

function DuplicatePage(props) {
    const classes = useStyles();
    const { projectQr } = useParams();

    const [FromDate, setFromDate] = useState(new Date());
    const [ToDate, setToDate] = useState(new Date());
    const [ResourceName, setResourceName] = useState("");
    const [CompanyName, setCompanyName] = useState("");
    const [CompanyId, setCompanyId] = useState(null);
    const [ProjectName, setProjectName] = useState("");
    const [companies, setCompanies] = useState([]);
    const [resources, setResources] = useState([]);
    const [types, setTypes] = useState([]);
    const [selectedResource, setSelectedResource] = useState("");

    const [allCurrencies, setAllCurrencies] = useState([]);
    const [activeCurrency, setActiveCurrency] = useState({ symbol: '€' });

    // TableDragResources
    const tableDragResourcesRef = useRef();

    const [projectRows, setProjectRows] = useState([]);
    const [open, setOpen] = useState(false);
    const [defopen, setDefOpen] = useState(false);
    const navigate = useNavigate();
    const GetUserId = props.Login.userid;
    const [helperTextProjectName, setHelperTextProjectName] = useState(null);
    const [helperTextCompany, setHelperTextCompany] = useState(null);
    const [helperTextResourceDescription, setHelperTextResourceDescription] = useState(null);
    const [errorProjectName, setErrorProjectName] = useState(false);
    const [errorCompany, setErrorCompany] = useState(false);
    const [errorResourceDescription, setErrorResourceDescription] = useState(false);
    const [emptyDetails, setEmptyDetails] = useState(false);
    const [singleStopwatch, setSingleStopwatch] = useState(false);


    // Page
    const [loading, setLoading] = useState(true);
    const [generalError, setGeneralError] = useState(null);

    useEffect(() => {
        if (allCurrencies.length > 0 && CompanyId !== null) {
            let selectedCompany = companies.find(x => x.id === CompanyId);
            let currency = allCurrencies.find(x => x.id === selectedCompany.currencyId);
            if (currency !== undefined) {
                setActiveCurrency(currency);
            }
        };
    }, [CompanyId, allCurrencies])

    useEffect(() => {
        var project;
        let tempProjectDetailRows = [];
        Promise.all([
            dataService.getAllCompaniesByUserId(props.Login.userid),
            dataService.getResources(props.Login.userid),
            dataService.getTypes(),
            dataService.getProjectByQr(projectQr),
            dataService.getProjectDetailsByQr(projectQr),
            dataService.getAllCurrencies()
        ]).then((results) => {
            //Set result-variables
            var companyResults = results[0];
            var resourcesResults = results[1];
            var typeResults = results[2];
            var projectResults = results[3];
            var projectDetailsResults = results[4];
            let allCurrencies = results[5];
            setCompanies(companyResults);
            setResources(resourcesResults);
            setAllCurrencies(allCurrencies);

            if (typeResults !== null) {
                setTypes(typeResults.sort((a, b) => a.description.localeCompare(b.description)));
            }

            if (projectResults !== null) {
                project = projectResults;
            } else {
                project = null;
            }
            if (projectDetailsResults !== null) {

                if (projectDetailsResults.some(x => x.id)) {
                    tempProjectDetailRows = projectDetailsResults.map(x => ({
                        comment: x.hasComment,
                        isParent: x.isParent,
                        color: x.color,
                        typeId: x.typeId,
                        type: x.typeId,
                        description: x.description,
                        Id: x.id,
                        edit: false,
                        accountId: x.accountId,
                        sequence: x.sequence,
                        dataListId: x.dataListId,
                        externalApiId: x.externalApiId,
                        price: x.price,
                        isProfit: x.isProfit,
                        costProfit: (x.isProfit ? '+' : '-'),
                        valueTypeId: x.valueTypeId,
                        priceBundleId: x.priceBundleId
                    }));
                }
            }

        }).catch((error) => {
            toast.error('Something went wrong while fetching the data.', { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
            console.log('Error: ', error)
        }).finally(() => {
            if (project !== null) {
                setProjectName(project.projectName);
                setCompanyName(project.companyName);
                setCompanyId(project.companyId);
                setResourceName(project.resourceDescription);
                setSingleStopwatch(project.isSingleStopwatch || false);

                let fDate = "";
                if (project.timeRangeBegin !== null) {
                    fDate = new Date(project.timeRangeBegin);
                }
                else {
                    fDate = new Date();
                }
                fDate.setHours(12, 0, 0, 0);
                setFromDate(fDate);
                let tDate = "";
                if (project.timeRangeEnd !== null) {
                    tDate = new Date(project.timeRangeEnd);
                }
                else {
                    tDate = new Date();
                }
                tDate.setHours(12, 0, 0, 0);
                setToDate(tDate);
            }
            if (tempProjectDetailRows !== undefined && tempProjectDetailRows !== null) {
                tempProjectDetailRows = tempProjectDetailRows.sort((a, b) => a.sequence - b.sequence);
            }
            setProjectRows(tempProjectDetailRows);
            setLoading(false);

        })

    }, [GetUserId, projectQr, props.Login.userid])

    const setProject = (event) => {
        setProjectName(event.target.value);
    }

    const setTheFromDate = (event) => {
        setFromDate(event);
    }

    const setTheToDate = (event) => {
        setToDate(event);
    }

    const handleDialogClose = () => {
        setOpen(false);
    }

    const handleDialogCloseDef = () => {
        setDefOpen(false);
    }

    const setNewCompanyFunction = (event) => {
        dataService.saveCompany(event.inputValue, GetUserId).then(results => {
            let newCompany = { id: results.id, name: results.name };
            let tempCompanies = [...companies];
            tempCompanies.push(newCompany);
            setCompanies(tempCompanies);
            setCompanyId(results.id);
            setCompanyName(results.name);
        }).catch((error) => {
            console.log(error);
            if (error.status === 403) {
                setGeneralError("You are not authorized to perform this action.");
            }
        })
    }

    const setCompany = (event) => {
        if (projectRows.length > 0) {
            let tempProjectDetailRows = projectRows.map(row => ({
                ...row,
                edit: true,
                accountId: null
            }));

            setProjectRows(tempProjectDetailRows);
        }
        if (event.inputValue) {
            if (companies.some(x => x.name === event.inputValue)) {
                setCompanyId(companies.find(x => x.name === event.inputValue).id);
                setCompanyName(event.inputValue);
            }
        }
        else {
            if (event.target.textContent) {
                if (companies.some(x => x.name === event.target.textContent)) {
                    setCompanyId(companies.find(x => x.name === event.target.textContent).id);
                    setCompanyName(event.target.textContent);
                }
            }
            else {

                if (companies.some(x => x.name === event.target.value)) {
                    setCompanyId(companies.find(x => x.name === event.target.value).id);
                }
                setCompanyName(event.target.value);
            }
        }

    }

    const setResource = (event, extra) => {
        if (event !== null && event.value !== undefined && resources.some(x => x.id === event.value)) {
            var selectedResourceElement = resources.find(x => x.id === event.value);
            setResourceName(selectedResourceElement.name);
            setSelectedResource(selectedResourceElement);

        } else if (event !== null && event !== undefined && event.target !== undefined && event.target !== null && event.target.value !== undefined) {
            setResourceName(event.target.value);
            setSelectedResource(null);
        } else {
            setSelectedResource(null);
            setResourceName("");
        }
    }

    const validateRows = async () => {
        if (tableDragResourcesRef.current) {
            try {
                const valid = await tableDragResourcesRef.current.validateAllRows();
                return valid;
            } catch (error) {
                return false; // Or handle as needed
            }
        }
    };

    const sendToApi = async () => {
        if (ProjectName === "" || ResourceName === "" || CompanyId === "" || CompanyName === "" || FromDate === "" || ToDate === "" || ResourceName === null || FromDate === null || ToDate === null || !(await validateRows())) {
            if (ProjectName === "") {
                setHelperTextProjectName("Please enter a project name.");
                setErrorProjectName(true);
            }
            else {
                setHelperTextProjectName(null);
                setErrorProjectName(false);
            }
            if (ResourceName === "" || ResourceName === null || ResourceName === undefined) {
                setHelperTextResourceDescription("Please select or enter a registration point.");
                setErrorResourceDescription(true);
            }
            else {
                setHelperTextResourceDescription(null);
                setErrorResourceDescription(false);
            }
            if (CompanyId === "" || CompanyId === null || CompanyName === "" || CompanyName === null || CompanyName === undefined) {
                setHelperTextCompany("Please Select or Create a Company.");
                setErrorCompany(true);
            }
            else {
                setHelperTextCompany(null);
                setErrorCompany(false);
            }
        }
        else {
            setHelperTextResourceDescription(null);
            setErrorResourceDescription(false);
            setHelperTextCompany(null);
            setErrorCompany(false);
            setHelperTextProjectName(null);
            setErrorProjectName(false);
            setEmptyDetails(false);
            if (projectRows.length === 0) {
                setEmptyDetails(true);
            }
            else {
                let tempProjectDetailRows = projectRows.map(row => ({
                    ...row,
                    edit: false
                }));
                setProjectRows(tempProjectDetailRows);
                let i = 1;
                let projectDetails = projectRows.map(x => ({ description: x.description, typeId: x.type, type: x.type, sequence: i++, color: x.color, dataListId: x.dataListId, accountId: x.accountId, HasComment: x.comment, IsParent: x.isParent, externalApiId: x.externalApiId, price: (x.price === "" || x.price === undefined || x.price === null ? 0 : parseFloat(String(x.price).replace(',', '.'))), isProfit: x.isProfit, valueTypeId: x.valueTypeId, priceBundleId: x.priceBundleId })).sort((a, b) => b.sequence + a.sequence);
                var resourceId = 0;
                if (selectedResource !== null && selectedResource !== undefined) {
                    resourceId = selectedResource.id;
                }
                dataService.createNewProject(GetUserId, ProjectName, ResourceName, resourceId, CompanyId, CompanyName, FromDate, ToDate, projectDetails, singleStopwatch).then(result => {
                    if (result.success === true) {
                        toast.success('Project was saved successfully', { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
                        navigate(`/modifyproject/${result.qrCode}`);
                    } else {
                        toast.error('Something went wrong.', { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
                    }
                }).catch((error) => {
                    if (error.status === 403) {
                        setGeneralError("You are not authorized to perform this action.");
                    } else {
                        setGeneralError("Something went wrong while saving the project.");
                    }
                });
            }

        }
    }

    const setDates = (fromDate, toDate) => {
        setTheToDate(toDate);
        setTheFromDate(fromDate);
    }

    const save = (newProjectRows) => {
        setProjectRows(newProjectRows);
    }
    return (
        <React.Fragment>
            {loading &&
                <div className={classes.loadingChart}><Spin width="100px" height="100px" color="var(--color-primary)"></Spin></div>
            }
            <Box className="page-container">
                <HeaderBar>
                    <HeaderTitle>Duplicate project</HeaderTitle>
                </HeaderBar>

                <Box className={classes.container}>
                    {generalError &&
                        <div className={classes.errorContainer}>
                            <p className={classes.errorMessage}>{generalError}</p>
                        </div>
                    }
                    <div className={classes.projectOptions}>
                        <div className={classes.projectOption}>
                            <label className={classes.labelContainer__label}>Project name</label>
                            <TextfieldInput value={ProjectName} action={setProject} label={ProjectName ? " " : "Project"} InputLabelProps={{ shrink: false }} helperText={helperTextProjectName} error={errorProjectName} />
                        </div>
                        <div className={classes.projectOption}>
                            <label className={classes.labelContainer__label}>Company</label>
                            <DropdownCompanyAdd companies={companies} value={CompanyName} action={setCompany} action2={setNewCompanyFunction} helperText={helperTextCompany} error={errorCompany} />
                        </div>
                        <div className={classes.projectOption}>
                            <div className={classes.projectOption__labelContainer}>
                                <label className={classes.labelContainer__label}>Registration point</label>
                                <Tooltip disableInteractive title="A registration point could be 'Welding machine 1'. It describes the location where you are taking measurements">
                                    <CircleHelp className={classes.labelContainer__help} />
                                </Tooltip>
                            </div>
                            <DropdownResources resources={resources} value={ResourceName} action={setResource} helperText={helperTextResourceDescription} error={errorResourceDescription} />
                        </div>
                    </div>

                    <Grid2 item xs={12} style={{ marginBottom: "-1rem" }}>
                        <DescriptionItem Text="Active between:" />
                        <DateSelectionFuture setDates={setDates} FromDate={FromDate} ToDate={ToDate} setTheFromDate={setTheFromDate} setTheToDate={setTheToDate} />
                        <Divider style={{ marginBottom: "2rem", marginTop: "1rem" }}></Divider>
                    </Grid2>
                    {/* Setting row */}
                    <div className={classes.projectSettingsRow}>
                        <BoolToggle
                            label="Single stopwatch"
                            size="large"
                            tooltipText="When toggled on, this project will only allow 1 running stopwatch at a time. Starting a new stopwatch will stop any other running stopwatches. (Beware, when using stopwatches in multiple projects, the stopwatch will be stopped for all projects.)"
                            boolValue={singleStopwatch}
                            onChange={setSingleStopwatch}
                        />
                    </div>
                    <div className={classes.projectOptionsContainer}>
                        {!CompanyId &&
                            <div className={classes.notAccessibleContainer}>
                                <div className={classes.notAccessibleCard}>
                                    <p className={classes.notAccessibleCard__title}>Please select a company to continue creating the project</p>
                                </div>
                            </div>
                        }
                        <Box style={{ border: emptyDetails && "solid 2px", borderColor: emptyDetails && "#d32f2f", borderRadius: emptyDetails && "5px", padding: '4px' }}>
                            <Grid2 item xs={12} sm={12} md={12}>
                                <TableDragResources ref={tableDragResourcesRef} {...props} types={types} currency={activeCurrency} rows={projectRows} setRows={setProjectRows} companyId={CompanyId} makeSave={save} />
                            </Grid2>
                            {emptyDetails &&
                                <p style={{ color: "#d32f2f", fontWeight: "400", fontSize: "0.75rem", fontFamily: "Roboto, Helvetica, Arial", letterSpacing: "0.03333em" }}>Please create at least one item.</p>
                            }
                        </Box>
                        {/* {emptyDetails ?
                            <div>
                                <Grid2 item xs={12} sm={12} md={12} style={{ border: "solid 2px", borderColor: "#d32f2f", borderRadius: "17px" }}>
                                    <TableDragResources {...props} types={types} rows={projectRows} setRows={setProjectRows} companyId={CompanyId} makeSave={save} />
                                </Grid2>
                                <p style={{ color: "#d32f2f", fontWeight: "400", fontSize: "0.75rem", fontFamily: "Roboto, Helvetica, Arial", letterSpacing: "0.03333em" }}>Please create at least one item.</p>
                            </div>
                            :
                            <div>
                                <Grid2 item xs={12} sm={12} md={12}>
                                    <TableDragResources ref={tableDragResourcesRef} {...props} types={types} rows={projectRows} setRows={setProjectRows} companyId={CompanyId} makeSave={save} />
                                </Grid2>
                            </div>
                        } */}
                    </div>

                    <div className={classes.buttonContainer}>
                        <button className={classes.primaryIconButton} onClick={sendToApi} >
                            <Save className={classes.iconButton__icon} />
                            Save
                        </button>
                    </div>
                </Box>
            </Box>
            {open &&
                <Dialog
                    open={open}
                    onClose={handleDialogClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Error"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Some fields are empty.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <ButtonNormalText content="Close" onClick={handleDialogClose}>Close</ButtonNormalText>
                    </DialogActions>
                </Dialog>
            }


            {defopen &&
                <Dialog
                    open={defopen}
                    onClose={handleDialogCloseDef}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Error"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Please make at least one Description item.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <ButtonNormalText content="Close" onClick={handleDialogCloseDef}>Close</ButtonNormalText>
                    </DialogActions>
                </Dialog>
            }

        </React.Fragment>
    )
}

export default DuplicatePage;
const useStyles = makeStyles((theme) => ({
    loadingChart: {
        height: '100vh',
        width: '100%',
        top: '0px',
        position: 'fixed',
        zIndex: '999',
        borderRadius: "8px",
        backgroundColor: 'rgba(156,156,156,0.5)',
        display: 'flex',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
    },
    container: {
        boxSizing: "border-box",
        position: 'relative',
        background: "#FFFFFF",
        borderRadius: "8px",
        padding: "1.5rem",
        maxWidth: "100%",
    },
    buttonContainer: {
        marginTop: '15px',
        display: 'flex',
        alignItems: 'center',
        float: 'right'

    },
    projectOptions: {
        display: 'flex',
        gap: "16px",

        [theme.breakpoints.up('sm')]: {
            flexWrap: 'nowrap',
            width: '100%'
        },
        [theme.breakpoints.down('sm')]: {
            flexWrap: 'wrap',
            width: '100%'
        }
    },
    projectOption: {
        display: "flex",
        flexDirection: "column",
        gap: "4px",

        [theme.breakpoints.up('md')]: {
            width: "100%",
            marginRight: '25px',
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },

    projectOption__labelContainer: {
        display: "flex",
        alignItems: "center",
        gap: "4px",
    },

    labelContainer__label: {
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",

        color: "rgba(12, 14, 41, 0.8)"
    },

    labelContainer__help: {
        height: "16px",
        width: "16px",

        display: "block",

        color: "rgba(12, 14, 41, 0.8)",

        transition: "color ease-in 0.2s",

        "&:hover": {
            color: "rgba(12, 14, 41, 1)",
        }
    },

    primaryIconButton: {
        height: "40px",
        padding: "0 16px",
        paddingLeft: "8px",

        border: "none",
        borderRadius: "4px",

        fontSize: "16px",
        color: "white",
        backgroundColor: "var(--color-primary)",

        display: "flex",
        gap: "8px",
        alignItems: "center",

        transition: "all 0.2s ease-in-out",

        "&:hover": {
            backgroundColor: "#a77d4f",
            color: "white",
            cursor: "pointer",
        }
    },

    iconButton__icon: {
        height: "20px",
        width: "20px",

        display: "block",
    },

    projectOptionsContainer: {
        position: "relative",
    },

    projectSettingsRow: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: "8px",
        marginBottom: "16px",
    },

    notAccessibleContainer: {
        width: "100%",
        height: "100%",

        position: "absolute",
        left: "0px",
        top: "0px",
        zIndex: "998",

        backgroundColor: "rgba(255, 255, 255, 0.6)",
        backdropFilter: "blur(8px)", // Apply blur to background elements

        borderRadius: "8px",

        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },

    notAccessibleCard: {
        maxWidth: "320px",
        boxSizing: "border-box",

        padding: "16px",

        display: "flex",
        flexDirection: "column",

        alignItems: "center",

        backgroundColor: "white",

        border: "1px solid #EDEDED",
        borderRadius: "8px",
    },

    notAccessibleCard__title: {
        fontFamily: "Lato, sans-serif",
        fontSize: "16px",
        color: "rgba(12, 14, 41, 1)",

        margin: "0px",
        marginBottom: "8px",
    },

    notAccessibleCard__subtitle: {
        fontFamily: "Lato, sans-serif",
        fontSize: "14px",
        color: "rgba(12, 14, 41, 0.8)",

        textAlign: "center",

        margin: "0px",
    },

    errorContainer: {
        width: "100%",
        backgroundColor: "#FDF3F3",

        border: "1px solid #FBE5E5",
        borderRadius: "6px",

        marginBottom: "16px",
        padding: "12px",
    },

    errorMessage: {
        fontSize: "16px",
        color: "#D84949"
    },
}));